import { useContext, useEffect } from 'react';
import { useSetPhoneFee } from './hooks/useOrderMutation';
import { OrderContext } from './OrderContext';
import { useUser } from '../../hooks/useUser';

export const useOrderPhoneFeeDefault = (): void => {
  const { user, isCCUser, isUserLoading } = useUser();
  const hasUser = Boolean(user);
  const setPhoneFee = useSetPhoneFee();
  const { order } = useContext(OrderContext);

  useEffect(() => {
    void (async (): Promise<void> => {
      try {
        if (isCCUser) {
          if (order.hasPhoneOrderFee === null) await setPhoneFee(true);
        } else if (!isUserLoading) {
          if (order.hasPhoneOrderFee !== null) await setPhoneFee(null);
        }
      } catch {
        // Errors are already surfaced via OrderProcessor's addError/trackInsightsException.
      }
    })();

    // We are only interested if user logs in/out or if phoneOrderFee is set to null by resetting order
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasUser, order.hasPhoneOrderFee]);
};
